import ApiService from "@/core/services/api.service";
const _ = require('lodash');

export const PATH_OKR = "okr";
export const GET_LIST_OKR = "GET_LIST_OKR";
export const GET_OKR_DETAIL = "GET_OKR_DETAIL";
export const CREATE_OKR = "CREATE_OKR";
export const UPDATE_OKR = "UPDATE_OKR";
export const SHARE_EXP_OKR = "okr/exp";
export const UPDATE_DEADLINE_OKR = "okr/update-progress"
export const UPDATE_STATUS_OKR = "okr/update-status";
export const GET_RESULT_OKR = "okr/result";
export const FIND_USER_BY_KEYWORD = "user/filter"

const state = {
    errors: null,
};

const getters = {};

const actions = {
    [GET_LIST_OKR](context, payload) {
        return new Promise((resolve) => {
            ApiService.query(PATH_OKR, payload).then(({data}) => {
                resolve(data);
            }).catch((res) => {
            });
        });
    },

    [GET_OKR_DETAIL](context, id) {
        return new Promise((resolve) => {
            ApiService.query(`${PATH_OKR}/${id}`).then(({data}) => {
                resolve(data);
            }).catch((res) => {
            });
        });
    },

    [GET_RESULT_OKR](context, payload) {
        return new Promise((resolve) => {
            ApiService.query(GET_RESULT_OKR, payload).then(({data}) => {
                resolve(data);
            }).catch((res) => {
            });
        });
    },

    [UPDATE_OKR](context, payload) {
        const {id, ...rest} = payload
        return new Promise((resolve, reject) => {
            ApiService.put(`${PATH_OKR}/${id}`, rest).then(({data}) => {
                resolve(data);
            }).catch(({response}) => {
                reject(response);
            });
        });
    },

    [UPDATE_DEADLINE_OKR](context, payload) {
        const {id, ...rest} = payload
        return new Promise((resolve, reject) => {
            ApiService.post(`${UPDATE_DEADLINE_OKR}/${id}`, rest).then(({data}) => {
                resolve(data);
            }).catch(({response}) => {
                reject(response);
            });
        });
    },

    [CREATE_OKR](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.post(PATH_OKR, payload).then(({data}) => {
                resolve(data);
            }).catch(({response}) => {
                reject(response);
            });
        });
    },

    [SHARE_EXP_OKR](context, payload) {
        const {id, ...rest} = payload
        return new Promise((resolve, reject) => {
            ApiService.post(`${SHARE_EXP_OKR}/${id}`, rest.data).then(({data}) => {
                resolve(data);
            }).catch(({response}) => {
                reject(response);
            });
        });
    },

    [UPDATE_STATUS_OKR](context, payload) {
        const {id, ...rest} = payload
        return new Promise((resolve) => {
            ApiService.post(`${UPDATE_STATUS_OKR}/${id}`, rest).then(({data}) => {
                resolve(data);
            }).catch((res) => {
            });
        });
    },

    [FIND_USER_BY_KEYWORD](context, payload) {
        return new Promise((resolve) => {
            ApiService.query(FIND_USER_BY_KEYWORD, payload).then(({data}) => {
                resolve(data);
            }).catch((res) => {
            });
        });
    },
}

const mutations = {};
export default {
    state,
    actions,
    mutations,
    getters
};
